import LayoutUiState from '@features/layout/mobX/LayoutUiState';
import { logScrollTrigger } from '@utils/scrollDebug';
export const LISTING_PRODUCT_DATA_ATTR = 'data-listing-product-id';
export const findListingProductNode = (productId: number): HTMLElement | null => {
  if (typeof document === 'undefined') return null;
  return document.querySelector(`[${LISTING_PRODUCT_DATA_ATTR}="${productId}"]`) as HTMLElement | null;
};
export const scrollToListingProduct = (productId: number, source: string): boolean => {
  const node = findListingProductNode(productId);
  if (!node) return false;
  const headerOffset = LayoutUiState.getLayoutFixedBarsHeight() + 16;
  const top = node.getBoundingClientRect().top + window.scrollY - headerOffset;
  logScrollTrigger(`${source} — scrollToListingProduct`, {
    productId,
    top,
    headerOffset,
    nodeRect: node.getBoundingClientRect()
  });
  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'instant'
  });
  return true;
};